import React, {FC} from 'react'
import {RouteComponentProps} from 'react-router-dom'
import classnames from 'classnames'
import '../styles/page/introduceDoc.less'

const NewMachinePro: FC<RouteComponentProps> = props => {
  return (
    <div className={classnames('new_machine_pro_box')}>
    <div className={classnames('new_machine_pro')}>
      <h2 className={classnames('pt36')}>一键新机功能介绍</h2>
      <p className={classnames('pt18')}> 基于hook框架，实现更换手机设备信息、CPU信息、wifi信息、传感器信息、多大上百种参数信息，从而生成一台新设备，兼具清理应用缓存备份历史机型等功能。</p>
      <h3 className={classnames('pt36')}>批量操作流程：</h3>
      <div className={classnames('pt24')}>1、状态：购买一键新机服务的设备会显示新机标签</div>
      <img className={classnames('pt18')} src={require('../assets/pro/newPhone.png')} alt=''/>
      <div className={classnames('pt38')}>2、设置：选择某一分组，点击一键新机服务</div>
      <img className={classnames('pt18')} src={require('../assets/pro/selectGroup.png')} alt=''/>
      <div className={classnames('pt18')}>3、选择设备：只可选择购买一键新机服务的设备</div>
      <img src={require('../assets/pro/newMachines.png')} alt=''/>
      <span className={classnames('pt18')}>*注：一键新机功能使用的历史记录，存在真机大师pro版本中，请进入下载中心，下载pro版本查看</span>

      <h3 className={classnames('pt36')}>真机大师Pro 操作流程：</h3>
      <div className={classnames('pt24')}>1、下载APK：购买真机后，进入设备-下载中心，下载真机大师Pro 版。</div>
      <img className={classnames('pt12')} src={require('../assets/pro/realPhone1.jpg')} alt=''/>
      <div className={classnames('pt24')}>2、历史记录：进入首页可以看到历史的设备变更记录，也方便用户恢复曾经用过的设备信息。</div>
      <img className={classnames('pt12')} src={require('../assets/pro/realPhone2.jpg')} alt=''/>
      <div className={classnames('pt24')}>3、清除缓存：点击生效时，可清除当前安装应用的缓存。对需要进行清除缓存的应用进行勾选即可。</div>
      <img className={classnames('pt12')} src={require('../assets/pro/realPhone3.jpg')} alt=''/>
    </div>
    </div>
  )
}
export default NewMachinePro
